
import Vue from "vue";
import { Sex, SexTypes } from "@/types/abstract";
import { castType, castTypeArray, ICast } from "@/types/cast";
export default Vue.extend({
  methods: {
    isMan(sex: Sex): boolean {
      return sex == SexTypes.Man;
    },
    isWoman(sex: Sex): boolean {
      return sex == SexTypes.Woman;
    },
    getFee(castType: castType):string{
      if(castType == castTypeArray.Premium){
        return '6,300'
      }
      if(castType == castTypeArray.Standard){
        return '4,125'
      }
      if(castType == castTypeArray.Economy){
        return '2,625'
      }
      return ''
    }
  },
  props: {
    userInfo: {
      type: Object as () => ICast,
    },
  },
});
